import { useConfirm } from "material-ui-confirm";

// Where a value is picked from the ones already in use but a new one may be typed — an admin tag, a
// saved query's section — a value nobody has used yet is confirmed before it is created, so a typo
// does not quietly become a value of its own. `kind` names what is being created ("section").
// Resolves to whether it was confirmed.
const useConfirmNewValue = (kind: string) => {
  const confirm = useConfirm();
  return async (value: string) => {
    try {
      await confirm({
        title: `New ${kind}`,
        description: `“${value}” has never been used. Create it?`,
        confirmationText: "Create",
      });
      return true;
    } catch {
      return false; // dismissed: material-ui-confirm rejects rather than resolving false
    }
  };
};

export default useConfirmNewValue;
